import { render, staticRenderFns } from "./bankaposekstresi.vue?vue&type=template&id=2b6a5e7c&scoped=true"
import script from "./bankaposekstresi.vue?vue&type=script&lang=js"
export * from "./bankaposekstresi.vue?vue&type=script&lang=js"
import style0 from "./bankaposekstresi.vue?vue&type=style&index=0&id=2b6a5e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6a5e7c",
  null
  
)

export default component.exports